// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2lF5k","head":"Table_head__2kyEl","col":"Table_col__3XPHn"};